import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { OfferAssignmentHttpClient } from './offer-assignment.http-client';
import { ReferralsOfferAssignmentActions } from './offer-assignment.store';

@Injectable({ providedIn: 'root' })
export class ReferralsOfferAssignmentEffects {
  public effects = createEffectFactory(ReferralsOfferAssignmentActions, this.actions$);

  public fetchOne$ = this.effects(ReferralsOfferAssignmentActions.fetchOne, ({ payload }) =>
    this.http.loadOfferAssignment(payload.id).pipe(
      map(data => ({
        data,
      })),
    ),
  );

  public fetchCollection$ = this.effects(ReferralsOfferAssignmentActions.fetchCollection, () =>
    this.http.loadOffersEnabled().pipe(
      map(data => ({
        data,
      })),
    ),
  );

  public toggle$ = this.effects(ReferralsOfferAssignmentActions.toggle, ({ payload }) =>
    this.http.offerRewardToggle(payload).pipe(
      map(data =>
        ReferralsOfferAssignmentActions.toggleSuccess({
          payload: {
            data,
          },
        }),
      ),
      catchError(error =>
        of(
          ReferralsOfferAssignmentActions.toggleFailed({
            payload: {
              offerId: payload.offerId,
              error,
            },
          }),
        ),
      ),
    ),
  );

  public assignReward$ = this.effects(ReferralsOfferAssignmentActions.assignReward, ({ payload }) =>
    this.http.offerRewardAssign(payload).pipe(
      map(data =>
        ReferralsOfferAssignmentActions.assignRewardSuccess({
          payload: {
            data,
          },
        }),
      ),
      catchError(error =>
        of(
          ReferralsOfferAssignmentActions.assignRewardFailed({
            payload: {
              offerId: payload.offerId,
              error,
            },
          }),
        ),
      ),
    ),
  );

  public assignTemplate$ = this.effects(
    ReferralsOfferAssignmentActions.assignTemplate,
    ({ payload }) =>
      this.http.assignTemplate(payload).pipe(
        map(data =>
          ReferralsOfferAssignmentActions.assignTemplateSuccess({
            payload: {
              data,
            },
          }),
        ),
        catchError(error =>
          of(
            ReferralsOfferAssignmentActions.assignTemplateFailed({
              payload: {
                slug: payload.slug,
                error,
              },
            }),
          ),
        ),
      ),
  );

  constructor(
    private actions$: Actions,
    private http: OfferAssignmentHttpClient,
  ) {}
}
